var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.86,
    height: 24.003,
    viewBox: "0 0 18.86 24.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(-54.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16742",
    "data-name": "Group 16742",
    transform: "translate(54.637 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11909",
    "data-name": "Path 11909",
    d: "M54.7,12.842a9.052,9.052,0,0,1,.311-3.631,9.257,9.257,0,0,1,8.769-6.587V.162a.179.179,0,0,1,.286-.127l5.12,3.723a.155.155,0,0,1,0,.249L64.071,7.731a.178.178,0,0,1-.286-.127V5.146a6.7,6.7,0,0,0-6.063,4.065,6.485,6.485,0,0,0-.518,2.9,6.566,6.566,0,0,0,1.462,3.777,1.252,1.252,0,0,1-.242,1.808,1.294,1.294,0,0,1-1.768-.244A8.987,8.987,0,0,1,54.7,12.842Zm14.783-4.73a6.5,6.5,0,0,1,.943,6.68,6.7,6.7,0,0,1-6.063,4.065V16.4a.179.179,0,0,0-.286-.127L58.955,20a.155.155,0,0,0,0,.249l5.115,3.723a.178.178,0,0,0,.286-.127V21.378a9.24,9.24,0,0,0,8.769-6.587,9.141,9.141,0,0,0,.311-3.631,8.94,8.94,0,0,0-1.95-4.613A1.294,1.294,0,0,0,69.719,6.3,1.256,1.256,0,0,0,69.482,8.112Z",
    transform: "translate(-54.637 0)",
    fill: "#ec6321"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.0a111d857be364660715e3c6ca9947f9.svg";
export { ForwardRef as ReactComponent };